import { createAction, props } from "@ngrx/store";

export const loadSedEvents= createAction('[SedEvents] Load');
export const loadSedEventsSuccess = createAction('[SedEvents] Load Success',props<{ sedEvents: any[] }>());
export const loadSedEventsFailure = createAction('[SedEvents] Load Failure',props<{ error: any }>());

